import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { RetailerTypesComponent } from '@src/app/features/retailer-types/retailer-types/retailer-types.component';
import { AddRetailerTypeComponent } from '@src/app/features/retailer-types/add-retailer-type/add-retailer-type.component';
import { ViewRetailerTypeComponent } from '@app/features/retailer-types/view-retailer-type/view-retailer-type.component';
import { EditRetailerTypeComponent } from '@src/app/features/retailer-types/edit-retailer-type/edit-retailer-type.component';

const routes: Routes = [
  { path: '', component: RetailerTypesComponent },
  { path: 'add', component: AddRetailerTypeComponent },
  { path: ':retailerTypeId/edit', component: EditRetailerTypeComponent },
  { path: ':retailerTypeId', component: ViewRetailerTypeComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RetailerTypesRoutingModule { }
